import { observer } from 'mobx-react';

import SectionTitle from '../../../../../../components/Titles/SectionTitle';
import UserSlideComponent from './UserSlideComponent';
import { IconUserVoice1, IconUserVoice2, IconUserVoice3 } from './IconUserVoice';

import './style.scss';

const imgUsers = [
    '/images/users-voice-1.png',
    '/images/users-voice-2.png',
    '/images/users-voice-3.png'
]

const iconUsers = [
    <IconUserVoice1 className='icon-user-voice' />,
    <IconUserVoice2 className='icon-user-voice' />,
    <IconUserVoice3 className='icon-user-voice' />
]

const UsersVoice = observer(({ data }) => {
    const slides = (Array.isArray(data?.boxs) && data?.boxs?.length > 0)
        // ? data?.boxs?.filter(item => item?.heading || item?.image?.url)
        ? data?.boxs
            ?.filter(item => item?.heading)
            ?.map((item, index) => ({
                ...item,
                image: {
                    url: imgUsers?.[index % imgUsers.length] || ''
                },
                icon: iconUsers?.[index % iconUsers.length] || undefined
            }))
        : [];

    return (
        <div id='id-users-voice' className='users-voice'>
            {slides?.length > 0 && data?.title && (
                <div className='users-voice__title'>
                    <SectionTitle title={data?.title || ''} outline={true} />
                </div>
            )}

            <div className='users-voice__content'>
                {Array.isArray(data?.boxs) && data?.boxs?.length > 0 && (
                    <UserSlideComponent slides={slides} />
                )}
            </div>
        </div>
    )
})

export default UsersVoice;
